import API, { graphqlOperation } from "@aws-amplify/api";
import * as queries from "graphql-custom/queries";

export function fetchCompanies() {
  return API.graphql(graphqlOperation(queries.listCompanies));
}
